import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import visuallyHidden from 'styles/visuallyHidden';

const styles = {
  hidden: visuallyHidden,
};

const MessageAnnounce = ({ classes, isRemoved, message, show }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    let timer;
    setIsShown(show);

    if (isRemoved && show && message) {
      timer = setTimeout(() => {
        setIsShown(false);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [isRemoved, message, show]);
  return (
    <div className={classnames('sr-message sr-only', classes.hidden)} aria-live="assertive">
      {isShown ? message : ''}
    </div>
  );
};

MessageAnnounce.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  isRemoved: PropTypes.bool,
  message: PropTypes.string,
  show: PropTypes.bool.isRequired,
};

MessageAnnounce.defaultProps = {
  isRemoved: false,
  message: '',
};

export default withStyles(styles)(MessageAnnounce);
